<template>
  <div class="privacy-page">
    <div class="container">
      <h1>隐私政策</h1>
      <div class="update-date">生效日期：2025年12月22日</div>
      
      <div class="info">
        <p><strong>公司名称：</strong>河北雄安思知科技有限公司</p>
        <p><strong>平台名称：</strong>小虫单</p>
        <p><strong>联系方式：</strong>如有任何疑问，请通过App内客服功能联系我们</p>
      </div>

      <p>河北雄安思知科技有限公司（以下简称"我们"）非常重视用户的隐私保护。本隐私政策说明了"小虫单"App（以下简称"本应用"）如何收集、使用、存储和保护您的个人信息。请您仔细阅读本隐私政策，在使用本应用前，您需要确认已充分理解并同意本政策的全部内容。</p>

      <h2>一、信息收集</h2>
      <p>为了向您提供更好的服务，我们可能会收集以下信息。我们在此明确说明各项信息的收集目的、方式与范围：</p>
      <ul>
        <li><strong>设备标识信息：</strong>包括设备型号、操作系统版本、设备唯一标识符（如 IMEI、Android ID、OAID 开放匿名设备标识符等），用于用户登录验证、设备绑定和账号安全保护。收集方式：通过应用及所集成的设备标识 SDK 在本地读取；收集范围：仅限实现上述目的所必需。</li>
        <li><strong>设备 MAC 地址：</strong>用于设备识别、安全风控与反作弊。收集目的：保障账号与设备安全、识别异常登录；收集方式：在您同意本政策后，由应用或所集成的 SDK 在合规前提下获取；收集范围：仅用于上述目的，不会用于无关的个性化推荐或对外共享。</li>
        <li><strong>软件安装列表：</strong>用于安全与兼容性检测、反作弊与风险控制。收集目的：识别运行环境、防范作弊与恶意行为；收集方式：在您同意本政策后，仅在必要时通过系统接口获取；收集范围：仅限实现安全与风控所必需，不会用于无关的画像或推荐。</li>
        <li><strong>位置信息：</strong>当您使用工单签到、店铺定位等功能时，我们会收集您的地理位置信息，用于记录签到位置、定位店铺位置等业务功能。</li>
        <li><strong>相机权限：</strong>当您使用拍摄工单照片、扫描二维码等功能时，我们会访问您的相机权限，用于拍摄和识别相关业务内容。</li>
        <li><strong>存储权限：</strong>当您需要保存工单照片、文件等数据时，我们会访问您的存储权限，用于保存和读取相关文件。</li>
        <li><strong>网络信息：</strong>包括IP地址、网络类型、网络状态等，用于确保应用正常联网和提供网络服务。</li>
        <li><strong>操作日志：</strong>包括您在使用本应用时的操作记录、功能使用情况等，用于分析应用性能、优化用户体验和排查问题。</li>
        <li><strong>账户信息：</strong>包括用户名、手机号码、部门信息、员工信息等，用于账户管理、权限控制和业务功能实现。</li>
        <li><strong>业务数据：</strong>包括工单信息、店铺信息、检查记录、统计数据等，用于提供核心业务功能。</li>
      </ul>

      <h2>二、信息使用</h2>
      <p>我们收集的信息将用于以下目的：</p>
      <ul>
        <li>提供、维护和改进本应用的服务功能；</li>
        <li>实现工单管理、店铺管理、部门管理、员工管理等核心业务功能；</li>
        <li>进行用户身份验证、账号安全保护和权限管理；</li>
        <li>记录和分析用户使用情况，优化应用性能和用户体验；</li>
        <li>发送重要通知、消息提醒和业务相关信息；</li>
        <li>遵守法律法规要求，配合相关部门的监管和调查；</li>
        <li>预防、发现和调查欺诈、滥用、安全威胁等行为；</li>
        <li>其他经您同意的用途。</li>
      </ul>

      <h2>三、信息存储</h2>
      <p>我们采用行业标准的安全措施保护您的个人信息：</p>
      <ul>
        <li>您的个人信息将存储在中华人民共和国境内，如需跨境传输，我们将严格按照相关法律法规执行；</li>
        <li>我们采用加密技术、访问控制等技术手段保护您的个人信息安全；</li>
        <li>我们仅会在实现本政策所述目的所必需的期间内保留您的个人信息，超出保存期限后，我们将删除或匿名化处理您的个人信息；</li>
        <li>当您删除账户或注销服务时，我们将删除或匿名化处理您的个人信息，法律法规另有规定的除外。</li>
      </ul>

      <h2>四、信息共享与披露</h2>
      <p>我们承诺不会向第三方出售、出租或以其他方式披露您的个人信息，但以下情况除外：</p>
      <ul>
        <li>获得您的明确同意或授权；</li>
        <li>法律法规要求或政府部门依法要求提供；</li>
        <li>为履行本政策或提供服务所必需，向我们的关联公司、合作伙伴或服务提供商提供（我们将要求其承担相应的保密义务）；</li>
        <li>在紧急情况下，为保护用户、我们或公众的生命、财产或重要利益；</li>
        <li>其他符合法律法规规定的情形。</li>
      </ul>

      <p><strong>与授权合作伙伴共享</strong></p>
      <p>为向您提供消息推送服务，我们接入了由每日互动股份有限公司提供的个推消息推送 SDK（UniPush）。我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给每日互动股份有限公司，用于为您提供消息推送技术服务。我们在向您推送消息时，可能会授权每日互动股份有限公司进行链路调节，相互促活被关闭的 SDK 推送进程，以保障您可以及时接收到我们向您推送的消息。详细内容请访问<a href="http://docs.getui.com/privacy" target="_blank" rel="noopener noreferrer">《个推用户隐私政策》</a>。</p>
      <p>为实现定位及地图展示功能（如工单签到、店铺定位等），我们接入了高德开放平台 SDK（包名：com.amap.api、com.loc、com.autonavi）。我们可能会将您的位置信息、存储的个人文件、设备状态与身份信息、网络信息提供给高德，用于实现定位与地图服务。详细内容请访问<a href="https://lbs.amap.com/agreement/compliance" target="_blank" rel="noopener noreferrer">《高德开放平台隐私政策》</a>。</p>
      <p>为实现分享、支付等功能，我们接入了微信开放平台 SDK（包名：com.tencent.mm，由深圳市腾讯计算机系统有限公司提供）。我们可能会将您的存储的个人文件、网络信息提供给微信，用于实现内容分享至微信、微信支付等能力。详细内容请访问<a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy" target="_blank" rel="noopener noreferrer">《微信隐私保护指引》</a>。</p>

      <h2>五、您的权利</h2>
      <p>您对自己的个人信息享有以下权利：</p>
      <ul>
        <li><strong>访问权：</strong>您有权访问您的个人信息，了解我们收集和使用您个人信息的情况；</li>
        <li><strong>更正权：</strong>您有权更正不准确或不完整的个人信息；</li>
        <li><strong>删除权：</strong>在符合法律法规规定的情况下，您有权要求删除您的个人信息；</li>
        <li><strong>撤回同意权：</strong>您有权撤回对个人信息处理的同意，但撤回同意不影响撤回前基于同意进行的个人信息处理的效力；</li>
        <li><strong>限制处理权：</strong>在符合法律法规规定的情况下，您有权要求限制对您个人信息的处理；</li>
        <li><strong>投诉举报权：</strong>如您认为我们的个人信息处理行为违反法律法规，您有权向相关监管部门投诉举报。</li>
      </ul>
      <p>您可以通过App内的设置功能或联系客服行使上述权利。</p>

      <h2>六、未成年人保护</h2>
      <p>我们非常重视对未成年人个人信息的保护。如果您是18周岁以下的未成年人，请在您的监护人陪同下仔细阅读本隐私政策，并在征得您的监护人同意后使用本应用。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，我们会设法尽快删除相关数据。</p>

      <h2>七、权限说明</h2>
      <p>本应用需要以下权限以实现相关功能：</p>
      <ul>
        <li><strong>位置权限：</strong>用于工单签到、店铺定位等功能，您可以在系统设置中随时关闭此权限；</li>
        <li><strong>相机权限：</strong>用于拍摄工单照片、扫描二维码等功能，仅在您主动使用相关功能时才会调用；</li>
        <li><strong>存储权限：</strong>用于保存工单照片和文件，您可以在系统设置中随时关闭此权限；</li>
        <li><strong>电话权限：</strong>用于获取设备标识信息以进行登录验证和设备绑定，不会实际拨打电话；</li>
        <li><strong>网络权限：</strong>用于应用正常联网和提供网络服务。</li>
      </ul>
      <p>您可以在设备的系统设置中管理这些权限，但关闭某些权限可能会影响相关功能的正常使用。</p>

      <h2>八、第三方 SDK 收集个人信息</h2>
      <p>为保障服务与安全，本应用集成了以下第三方 SDK。我们在此准确写明 SDK 名称及对应收集的个人信息，并明确各项信息的收集目的、收集方式与收集范围。</p>

      <p><strong>1. 移动智能终端补充设备标识体系统一调用 SDK（MIIT 设备标识 SDK，com.bun.miitmdid 等相关实现）</strong></p>
      <ul>
        <li><strong>行为主体类型：</strong>SDK</li>
        <li><strong>SDK 收集的个人信息类型：</strong></li>
      </ul>
      <ul style="list-style: none; margin-left: 1em;">
        <li>（1）开放匿名设备标识符（OAID）、开发者匿名设备标识符（VAID）、应用匿名设备标识符（AAID）及设备品牌、型号、网络运营商等与设备标识相关的信息。</li>
        <li>（2）<strong>设备 MAC 地址</strong></li>
        <li>（3）<strong>软件安装列表</strong></li>
        <li>（4）<strong>设备序列号</strong>（设备硬件序列号，非泛指“设备硬件信息”）</li>
      </ul>
      <ul>
        <li><strong>收集目的：</strong>用于生成与读取设备匿名标识（OAID/VAID/AAID），实现设备识别、安全风控、反作弊与统计；设备 MAC 地址、软件安装列表、设备序列号用于设备唯一性识别与安全风控，不用于跨应用追踪或无关的个性化推荐。</li>
        <li><strong>收集方式：</strong>仅在您同意本隐私政策后由本应用调用该 SDK；SDK 通过系统接口在本地读取上述信息，不涉及本应用主动向第三方上传上述数据。</li>
        <li><strong>收集范围：</strong>仅限实现上述目的所必需；我们要求该 SDK 不存储、不向第三方传输上述个人信息。更多说明可参考中国信通院移动安全联盟：http://www.msa-alliance.cn。</li>
      </ul>

      <p><strong>2. 个推消息推送 SDK（UniPush，由每日互动股份有限公司提供）</strong></p>
      <ul>
        <li><strong>行为主体类型：</strong>SDK</li>
        <li><strong>SDK 收集的个人信息类型：</strong>设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息。</li>
        <li><strong>收集目的：</strong>用于为您提供消息推送技术服务；在向您推送消息时可能进行链路调节，相互促活被关闭的 SDK 推送进程，以保障您及时收到我们推送的消息。</li>
        <li><strong>收集方式：</strong>在您同意本隐私政策后，由本应用调用该 SDK，SDK 通过系统接口获取上述信息并可能提供给每日互动股份有限公司用于推送服务。</li>
        <li><strong>收集范围：</strong>仅限实现消息推送服务所必需。详细内容请访问<a href="http://docs.getui.com/privacy" target="_blank" rel="noopener noreferrer">《个推用户隐私政策》</a>。</li>
      </ul>

      <p><strong>3. 高德开放平台 SDK（包名：com.amap.api、com.loc、com.autonavi）</strong></p>
      <ul>
        <li><strong>行为主体类型：</strong>SDK</li>
        <li><strong>使用目的：</strong>实现定位及地图展示（如工单签到、店铺定位等）。</li>
        <li><strong>使用的权限：</strong>粗略位置（ACCESS_COARSE_LOCATION）、精确定位（ACCESS_FINE_LOCATION）、网络状态（ACCESS_NETWORK_STATE）、WiFi 状态（ACCESS_WIFI_STATE、CHANGE_WIFI_STATE）、读取手机状态（READ_PHONE_STATE）、写入外部存储（WRITE_EXTERNAL_STORAGE）、位置扩展命令（ACCESS_LOCATION_EXTRA_COMMANDS）。</li>
        <li><strong>涉及个人信息：</strong>存储的个人文件、位置信息、设备状态与身份信息、网络信息。</li>
        <li><strong>收集方式与范围：</strong>在您同意本隐私政策并使用定位/地图相关功能时，由本应用调用该 SDK 获取上述信息，仅限实现定位与地图服务所必需。详细内容请访问<a href="https://lbs.amap.com/agreement/compliance" target="_blank" rel="noopener noreferrer">《高德开放平台隐私政策》</a>。</li>
      </ul>

      <p><strong>4. 微信开放平台 SDK（包名：com.tencent.mm，由深圳市腾讯计算机系统有限公司提供）</strong></p>
      <ul>
        <li><strong>行为主体类型：</strong>SDK</li>
        <li><strong>使用目的：</strong>实现分享至微信、微信支付等功能。</li>
        <li><strong>使用的权限：</strong>网络状态（ACCESS_NETWORK_STATE）、WiFi 状态（ACCESS_WIFI_STATE）。</li>
        <li><strong>涉及个人信息：</strong>存储的个人文件、网络信息。</li>
        <li><strong>收集方式与范围：</strong>在您同意本隐私政策并使用分享、支付等相关功能时，由本应用调用该 SDK 获取上述信息，仅限实现分享与支付服务所必需。详细内容请访问<a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy" target="_blank" rel="noopener noreferrer">《微信隐私保护指引》</a>。</li>
      </ul>
      <p>我们会对接入的 SDK 进行合规管理，要求其遵守相关法律法规。如您对某 SDK 的收集行为有疑问，可通过本政策第十一条联系方式向我们反馈。</p>

      <h2>九、其他第三方服务</h2>
      <p>本应用可能包含其他第三方服务提供商的链接或服务，这些第三方服务有其独立的隐私政策。我们不对第三方服务的隐私做法负责，建议您仔细阅读第三方的隐私政策。</p>

      <h2>十、隐私政策更新</h2>
      <p>我们可能会不定期更新本隐私政策。更新后的隐私政策将在本页面公布，并在显著位置提示您查看。重大变更时，我们还会通过App内通知等方式告知您。更新后的隐私政策自公布之日起生效。如您继续使用本应用，即视为您已接受更新后的隐私政策。</p>

      <h2>十一、联系我们</h2>
      <p>如果您对本隐私政策有任何疑问、意见或建议，或需要行使相关权利，请通过以下方式联系我们：</p>
      <ul>
        <li>通过App内客服功能联系我们；</li>
        <li>发送邮件至我们的客服邮箱（support@xcdan.com）。</li>
      </ul>
      <p>我们将在收到您的反馈后尽快回复。</p>

      <div class="footer">
        <p>河北雄安思知科技有限公司</p>
        <p>小虫单平台</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'PrivacyPage',
  mounted() {
    // 页面加载动画
    this.$nextTick(() => {
      document.querySelector('.container')?.classList.add('fade-in')
    })
  }
}
</script>

<style lang="scss" scoped>
.privacy-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  animation: fadeIn 0.6s ease;

  .container {
    max-width: 900px;
    margin: 0 auto;
    background-color: #fff;
    padding: 40px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h1 {
    font-size: 28px;
    color: #1B5898;
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #1B5898;
    animation: slideDown 0.6s ease;
  }

  h2 {
    font-size: 20px;
    color: #1B5898;
    margin-top: 30px;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 4px solid #1B5898;
    animation: slideInLeft 0.5s ease;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
    text-indent: 2em;
    line-height: 1.8;
    color: #333;
    animation: fadeInUp 0.5s ease;
  }

  a {
    color: #1B5898;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .info {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f9f9f9;
    border-left: 4px solid #1B5898;
    border-radius: 4px;
    animation: fadeInUp 0.5s ease 0.2s both;

    p {
      text-indent: 0;
      margin-bottom: 5px;
    }
  }

  ul {
    margin-left: 2em;
    margin-bottom: 15px;
    animation: fadeInUp 0.5s ease;

    li {
      margin-bottom: 8px;
      line-height: 1.8;
      color: #333;
    }
  }

  .footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
    text-align: right;
    color: #666;
    font-size: 14px;
    animation: fadeInUp 0.5s ease;
  }

  .update-date {
    text-align: center;
    color: #999;
    font-size: 14px;
    margin-bottom: 30px;
    animation: fadeIn 0.5s ease;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .privacy-page {
    padding: 10px;

    .container {
      padding: 20px;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 18px;
    }

    p {
      font-size: 14px;
    }
  }
}
</style>

